import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/right.png'
import _imports_1 from '@/assets/images/auth.png'
import _imports_2 from '@/assets/images/icon1.png'
import _imports_3 from '@/assets/images/nodata.png'


const _withScopeId = n => (_pushScopeId("data-v-f965dbac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "advertisAdmin" }
const _hoisted_2 = { class: "head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"14px","height":"14px","margin-left":"5px","margin-right":"5px"}
}, null, -1))
const _hoisted_4 = { style: {"fontsize":"14px","color":"#161616"} }
const _hoisted_5 = { class: "head_item" }
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = { class: "left" }
const _hoisted_8 = { class: "left_top" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "auth"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_13 = { class: "left_bottom" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sepview" }, null, -1))
const _hoisted_15 = { class: "statistical" }
const _hoisted_16 = { class: "item" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "content" }
const _hoisted_19 = { class: "item" }
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "content" }
const _hoisted_22 = { class: "item" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = { class: "content" }
const _hoisted_25 = { class: "item" }
const _hoisted_26 = { class: "title" }
const _hoisted_27 = { class: "content" }
const _hoisted_28 = { class: "item" }
const _hoisted_29 = { class: "title" }
const _hoisted_30 = { class: "content1" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sepview" }, null, -1))
const _hoisted_32 = { class: "items" }
const _hoisted_33 = { class: "title bold1" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "item item1" }
const _hoisted_36 = { class: "left" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode("USDT ")
const _hoisted_39 = { class: "item item2" }
const _hoisted_40 = { class: "left" }
const _hoisted_41 = { class: "right" }
const _hoisted_42 = { class: "item item3" }
const _hoisted_43 = { class: "left" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right1" }, null, -1))
const _hoisted_45 = {
  key: 1,
  class: "nodata"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_47 = { style: {"margin-top":"10px","color":"#C2C2C2","font-size":"14px"} }
const _hoisted_48 = { class: "items items2" }
const _hoisted_49 = { class: "title bold1" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "item item1" }
const _hoisted_52 = { class: "left" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_54 = /*#__PURE__*/_createTextVNode("USDT ")
const _hoisted_55 = { class: "item item2" }
const _hoisted_56 = { class: "left" }
const _hoisted_57 = { class: "right" }
const _hoisted_58 = { class: "item item3" }
const _hoisted_59 = { class: "left" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right1" }, null, -1))
const _hoisted_61 = {
  key: 1,
  class: "nodata"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_63 = { style: {"margin-top":"10px","color":"#C2C2C2","font-size":"14px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_document_copy = _resolveComponent("document-copy")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_payment_view = _resolveComponent("payment-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        style: {"fontsize":"14px","color":"#418CFA"},
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gotoBack && _ctx.gotoBack(...args)))
      }, _toDisplayString(_ctx.pageName), 1),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.langObj.l0399), 1)
    ]),
    _createVNode(_component_el_row, { style: {"background":"#fff","padding":"0px 20px 20px 0px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.user.nickName ? _ctx.user.nickName.substring(0, 1) : _ctx.user.username.substring(0, 1)), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.user.nickName ? _ctx.user.nickName : _ctx.user.username), 1),
                  _createElementVNode("div", {
                    class: "id",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyAction && _ctx.copyAction(...args)))
                  }, "ID:" + _toDisplayString(_ctx.user.userId), 1),
                  _createVNode(_component_el_icon, {
                    class: "fontBright",
                    onClick: _ctx.copyAction
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_document_copy)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _hoisted_10,
                  (_ctx.merchant == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("div", null, _toDisplayString(_ctx.langObj.l0128), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.langObj.l0129 + "：" + _ctx.user.phone), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.langObj.l0130 + "：" + _ctx.formatDateTime(_ctx.user.createTime ? _ctx.user.createTime : 1611368449782)), 1)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 4 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.langObj.l0153), 1),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.otcData.success), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 4 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.langObj.l0154), 1),
                _createElementVNode("div", _hoisted_21, _toDisplayString((_ctx.otcData.successRatio * 100).toFixed(0)) + "%", 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 4 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.langObj.l0155), 1),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.otcData.successByMonth), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 4 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.langObj.l0156), 1),
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.getCountdown(_ctx.otcData.avgPermitTime)), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 8 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.langObj.l0157) + "USDT", 1),
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.mortgageNum), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_31,
    (_ctx.sellList.length > 0 && _ctx.buyList.length > 0)
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          gutter: 20,
          class: "advertis"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 12,
              style: {"padding-bottom":"120px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.langObj.l0159), 1),
                  (_ctx.sellList.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sellList, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "itemBox",
                            key: item
                          }, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _hoisted_37,
                                _createElementVNode("span", null, _toDisplayString(_ctx.langObj.l0018), 1),
                                _hoisted_38
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _createTextVNode(_toDisplayString(_ctx.langObj.l0033 + Number(item.amount).toFixed(6)) + "USDT ", 1),
                                _createElementVNode("span", null, _toDisplayString(_ctx.langObj.l0008 +
                                                _ctx.Config.currency.symbol +
                                                Number(item.minQuota).toFixed(2) +
                                                "~" +
                                                _ctx.Config.currency.symbol +
                                                Number(item.maxQuota).toFixed(2)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_41, [
                                _createTextVNode(_toDisplayString(_ctx.langObj.l0006) + " ", 1),
                                _createElementVNode("span", null, _toDisplayString(_ctx.Config.currency.symbol + Number(item.unitPrice).toFixed(2)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("div", null, _toDisplayString(_ctx.langObj.l0034) + ":", 1),
                                _createVNode(_component_payment_view, {
                                  paymethodId: item.paymentMethodId
                                }, null, 8, ["paymethodId"])
                              ]),
                              _hoisted_44
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _hoisted_46,
                        _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.langObj.l0055), 1)
                      ]))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.langObj.l0163), 1),
                  (_ctx.buyList.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buyList, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "itemBox",
                            key: item
                          }, [
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                _hoisted_53,
                                _createElementVNode("span", null, _toDisplayString(_ctx.langObj.l0017), 1),
                                _hoisted_54
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, [
                                _createTextVNode(_toDisplayString(_ctx.langObj.l0033 + Number(item.amount).toFixed(6)) + "USDT ", 1),
                                _createElementVNode("span", null, _toDisplayString(_ctx.langObj.l0008 +
                                                _ctx.Config.currency.symbol +
                                                Number(item.minQuota).toFixed(2) +
                                                "~" +
                                                _ctx.Config.currency.symbol +
                                                Number(item.maxQuota).toFixed(2)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_57, [
                                _createTextVNode(_toDisplayString(_ctx.langObj.l0006) + " ", 1),
                                _createElementVNode("span", null, _toDisplayString(_ctx.Config.currency.symbol + Number(item.unitPrice).toFixed(2)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("div", null, _toDisplayString(_ctx.langObj.l0034) + ":", 1),
                                _createVNode(_component_payment_view, {
                                  paymethodId: item.paymentMethodId
                                }, null, 8, ["paymethodId"])
                              ]),
                              _hoisted_60
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _hoisted_62,
                        _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.langObj.l0055), 1)
                      ]))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}